import { Home, computeScore } from './app/home';
import ideas from './data/ideas.json';
import amplitude from 'amplitude-js';
import React from 'react';

amplitude.getInstance().init('ea6d1dd2720a0a4869d8e75678d16d76');

export const DB = {
    app: process.env.REACT_APP_MONGO_APP as string,
    name: process.env.REACT_APP_MONGO_DB  as string,
    collection: process.env.REACT_APP_COLLECTION  as string
}

export const App = () => <Home
    ideas = { ideas.map((i) => ({ 
        ...i, 
        score: computeScore(i.results),
        pitch: i.pitch || i.description.split(' ').reduce((d, i, idx) => 
            idx > 10 ? `${ idx === 11 ? `${d}...` : d}` : `${d} ${i}`, ''
        )
    })) }
/>
